import { Link, Outlet } from 'react-router-dom'
import { SideBar } from '../../components/SideBar/index'
import { Container } from './styles'
import { MyOrder } from '../../components/MyOrder'
import { HeadPerfilLogo } from '../../components/HeadPerfilLogo'

export default function Main() {
  return (
    <Container>
      <SideBar />
      <div>
        <section>
          <HeadPerfilLogo />
          <Outlet />
        </section>
        <MyOrder />
        <footer>
          Feito por <Link to='#'>Marcelo</Link> | &copy; todos os direitos reservados
        </footer>
      </div>
    </Container>
  )
}
